__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-document-uploader'].baseUrl;
/* istanbul ignore file */

import ModuleContainer from './components/DocUpload';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      'iguazu': '^3.2.0',
      'iguazu-rest': '^1.8.0'
    }
  });
}